import { Components } from "@thisgorilla/primate-ds";
import { useMemo } from "react";
import styled, { useTheme } from "styled-components";

import { API_CALLS } from "../../../API/api_calls";
import { useAppSelector } from "../../../redux";
import { getPeopleNamesText } from "../../../utils";
import { UserCardProps } from "./UserCard";

const UserFollowersInfo = (user: UserCardProps.User) => {
  const {
    followAUser_API_STATUS,
    unfollowAUser_API_STATUS,
    selectedUserId,
    followingIds,
  } = useAppSelector((state) => state.connections);
  const { Color, typography } = useTheme();
  const { total_followers, followers, id } = user;

  const followersNamesText = useMemo(
    () => getPeopleNamesText(followers),
    [followers]
  );
  const isFollowing = followingIds[id];

  const handleFollow = () => API_CALLS.CONNECTIONS.followAUser({ id });
  const handleUnfollow = () => API_CALLS.CONNECTIONS.unfollowAUser({ id });

  return (
    <FollowButtonAndInfoContainer>
      <FollowInfoContainer>
        {total_followers > 0 && (
          <Components.AvatarGroup
            srcCountToBeRendered={total_followers >= 2 ? 2 : followers.length}
            src={followers.map((follower) => follower.profile_picture)}
            size="XXSmall-20"
          />
        )}
        <Components.Text
          text={(followersNamesText ? "Followed by " : "") + followersNamesText}
          maxLineLength={2}
          style={{ tokenStyle: typography.Body.S }}
          color={Color.text["text-tertiary"].value}
        />
      </FollowInfoContainer>
      <Components.Button
        color="Neutral"
        kind="Secondary"
        disabled={false}
        label={isFollowing ? "Following" : "Follow"}
        onClick={() => {
          if (followAUser_API_STATUS === "progress") return;
          if (unfollowAUser_API_STATUS === "progress") return;

          isFollowing ? handleUnfollow() : handleFollow();
        }}
        size="XS"
        iconType={
          isFollowing
            ? undefined
            : followAUser_API_STATUS === "progress" && selectedUserId === id
            ? "MoreHorizontal"
            : "Plus"
        }
        iconPosition="left"
      />
    </FollowButtonAndInfoContainer>
  );
};

export default UserFollowersInfo;

const FollowInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
`;

const FollowButtonAndInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
`;
